import template from '../templates/Subscription.ejs';
import tooltip from 'helpers/tooltip';

module.exports = Backbone.View.extend({
    events: {
        'click .js-online-payment': 'onlinePayment'
    },

    render: function() {
        this.$el.html(template({
            model: this.model,
            collection: this.collection
        }));

        if (this.collection.length) {
            this.$('.js-empty').hide();
        } else {
            this.$('.js-table-invoices').hide();
        }

        tooltip.init(this);
    },

    onlinePayment: function(e) {
        e.preventDefault();

        const invoiceId = $(e.currentTarget).data('id');
        const invoice = this.collection.find(i =>
            i.id === invoiceId);

        if (!invoice) {
            return false;
        }

        this.model.onlinePayment(invoiceId)
            .then(response => {
                window.location.replace(response.result.url);
            });
    }
});



// WEBPACK FOOTER //
// ./app/mpp/views/Subscription.js